import { emailValidationRegex, beneficiaryNameRegex, phoneNumberValidationRegex } from "../app_methods";
import { get, post, put } from "../services/HttpService";


export class Contact {
    constructor(contactObject = {}) {
        this.set(contactObject);
    };

    static validations = {
        "id": [],
        "uuid": [],
        "address": [],
        "city": [],
        "state": [],
        "pincode": [],
        "status": [],
        "created_at": [],
        "name": [
            { required: true, message: "Name is required." },
            { pattern: beneficiaryNameRegex(), message: 'Please enter a valid name.' },
            { min: 1, message: "Must be atlest 1 characters long" },
            { max: 100, message: "Can be of maximum 100 characters" }
        ],
        "email": [
            { required: true, message: "Email is required." },
            { pattern: emailValidationRegex(), message: "Please enter a valid Email ID." },
            { min: 1, message: "Must be atlest 1 characters long" },
            { max: 150, message: "Can be of maximum 100 characters" }
        ],
        "phone": [
            { pattern: phoneNumberValidationRegex(), message: "Please enter a valid phone number." }
        ]
    };

    /**
     * @memberof Contact
     * @type API
     * @returns Promise
     */
    static list = (queryData = {}, config = {}) => {
        return get(`v1/internal/contacts/`, queryData, config).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    };
    
    /**
     * @memberof Contact
     * @type API
     * @returns Promise
     */
    static list_v2 = (queryData = {}, config = {}) => {
        return get(`v2/internal/contacts/`, queryData, config).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    };

    /**
     * @memberof Contact
     * @type API
     * @returns Promise
     */
    retreive = (queryData = {}, config = {}) => {
        return get(`v1/internal/contacts/${this.uuid}/`, queryData, config).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    };

    /**
     * @memberof Contact
     * @type API
     * @returns Promise
     */
    save = () => {
        let queryData = this.get();
        if (queryData.id) return put(`v1/internal/contacts/${this.id}/`, queryData, {}).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
        return post(`v1/internal/contacts/`, queryData, {}).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    };

    /**
     * @memberof Contact
     * @type Getter Method
     * @takes void
     * @returns Contact Params
     */
    get = () => {
        return {
            id: this.id,
            name: this.name,
            email: this.email,
            phone: this.phone,
            address: this.address,
            city: this.city,
            state: this.state,
            pincode: this.pincode,
            status: this.status
        }
    };

    /**
     * @memberof Contact
     * @type Setter Method
     * @takes Contact Params
     * @returns void
     */
    set = (values) => {
        Object.keys(values).forEach(x => this[x] = values[x]);
    };

    /**
     * @memberof Contact
     * @type Setter Method
     * @takes Contact Params
     * @returns void
     */
    reset = () => {
        this.id = undefined;
        this.name = undefined;
        this.email = undefined;
        this.phone = undefined;
        this.address = undefined;
        this.city = undefined;
        this.state = undefined;
        this.pincode = undefined;
        this.status = undefined;
    };
}